import type { RouteObject } from "react-router-dom";

export const aiExchangeAnalyticsRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "AI Exchange Analytics" },
    async lazy() {
      const { Page } = await import("../../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { AiExchangeAnalytics } =
            await import("./ai-exchange-analytics");
          return { Component: AiExchangeAnalytics };
        },
      },
    ],
  },
];
